export const serviceJourneys = [
  {
    key: "undergraduate-abroad",
    title: "Undergraduate Abroad",
    href: "https://nexteraabroad.com/",
    external: true,
    audience: "Students seeking international undergraduate programs",
    summary:
      "Expert guidance for studying undergraduate programs abroad across top destinations — USA, UK, Canada, Australia, and more — with end-to-end application support.",
    supportPoints: [
      "Destination and university shortlisting",
      "Application & visa documentation support",
      "Scholarship and funding guidance"
    ],
    bestFor:
      "Students who want a global undergraduate education with structured, trusted support throughout the journey."
  },
  {
    key: "bachelors-india",
    title: "Bachelor's Admissions in India",
    to: "/bachelors-india",
    audience: "Class 12 students and families exploring undergraduate options",
    summary:
      "Guidance across bachelor pathways with practical shortlisting based on profile, priorities, and admission timelines.",
    supportPoints: [
      "Stream and course-direction discussions",
      "College shortlist aligned to fit and affordability",
      "Application and documentation guidance"
    ],
    bestFor:
      "Students deciding after Class 12 and families comparing practical options."
  },
  {
    key: "masters-india",
    title: "Master's Admissions in India",
    to: "/masters-india",
    audience: "Graduates planning focused post-graduate progression",
    summary:
      "Counselling for master's admissions with course-path clarity, intake planning, and structured decision support.",
    supportPoints: [
      "Course and specialization fit discussions",
      "Profile-led college selection",
      "Timeline and process support"
    ],
    bestFor:
      "Graduates who need clarity on next academic and career-linked steps."
  },
  {
    key: "mbbs-india",
    title: "MBBS in India",
    to: "/mbbs-india",
    audience: "Students and parents evaluating MBBS pathways within India",
    summary:
      "High-trust counselling for MBBS planning in India with clear option discussions and process clarity for families.",
    supportPoints: [
      "Guided planning conversations",
      "Balanced option evaluation",
      "Structured process handholding"
    ],
    bestFor:
      "Families looking for careful, practical support for medical admission decisions."
  },
  {
    key: "mbbs-abroad",
    title: "MBBS Abroad",
    to: "/mbbs-abroad",
    audience: "Students and families evaluating international MBBS options",
    summary:
      "Reassuring guidance for MBBS abroad decisions with emphasis on fit, planning discipline, and informed family choices.",
    supportPoints: [
      "Country and college-fit evaluation",
      "Family-oriented decision discussions",
      "Application journey support"
    ],
    bestFor:
      "Students exploring MBBS abroad who need structured and grounded guidance."
  }
];

export const servicesProcess = [
  {
    step: "01",
    title: "Understand goals and profile",
    description:
      "Every journey starts with student goals, academics, context, and family priorities."
  },
  {
    step: "02",
    title: "Curate realistic options",
    description:
      "Shortlists are built around fit, affordability, and practical admission possibilities."
  },
  {
    step: "03",
    title: "Guide applications and documents",
    description:
      "Documentation and applications are supported with clear sequencing and checkpoints."
  },
  {
    step: "04",
    title: "Support decisions and closure",
    description:
      "Final choice support continues until the admission journey is properly completed."
  }
];

export const servicesComparisonRows = [
  {
    label: "Typical stage",
    bachelors: "After Class 12",
    masters: "After graduation",
    mbbsIndia: "Medical pathway planning in India",
    mbbsAbroad: "International medical pathway evaluation"
  },
  {
    label: "Primary focus",
    bachelors: "Course + college fit",
    masters: "Specialization + progression fit",
    mbbsIndia: "Careful option clarity",
    mbbsAbroad: "Country + college evaluation"
  },
  {
    label: "Family involvement",
    bachelors: "High",
    masters: "Moderate to high",
    mbbsIndia: "Very high",
    mbbsAbroad: "Very high"
  },
  {
    label: "Support style",
    bachelors: "Guided shortlisting",
    masters: "Profile-led strategic planning",
    mbbsIndia: "Structured guidance",
    mbbsAbroad: "Reassurance-led guided planning"
  }
];
